module.exports = __webpack_public_path__ + "static/media/id-badge.4e6cd086.svg";